import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { BulkAllocationState } from '../interfaces/interface';
import { createBulkAnalyse, createDataAnalyseUnallocation, createTaskStatusAnalyse } from '../slices/bulkAllocation/index';

const ExtraReducers = (builder: ActionReducerMapBuilder<BulkAllocationState>) => {
  builder
    .addCase(createBulkAnalyse.pending, (state) => {
      state.createStatus = STATUS.PENDING;
      state.createBulkAnalyseMessage = null
    })
    .addCase(createBulkAnalyse.fulfilled, (state, action: PayloadAction<any>) => {
      state.bulkAllocation = action.payload; 
      state.createStatus = STATUS.SUCESS; 
      state.createBulkAnalyseMessage = null
    })
    .addCase(createBulkAnalyse.rejected, (state, action:any) => { 
      state.createStatus = STATUS.FAILED;
      state.createBulkAnalyseMessage = action.payload?.message || "An error occurred"
    })
    .addCase(createDataAnalyseUnallocation.pending, (state) => {
      state.createDataAnalyseUnallocationStatus = STATUS.PENDING;
      state.createDataAnalyseUnallocationMessage = null
    })
    .addCase(createDataAnalyseUnallocation.fulfilled, (state, action: PayloadAction<any>) => {
      state.dataUnallocation = action.payload; 
      state.createDataAnalyseUnallocationStatus = STATUS.SUCESS; 
      state.createDataAnalyseUnallocationMessage = null
    })
    .addCase(createDataAnalyseUnallocation.rejected, (state, action:any) => { 
      state.createDataAnalyseUnallocationStatus = STATUS.FAILED;
      state.createDataAnalyseUnallocationMessage = action.payload?.message || "An error occurred"
    })
    .addCase(createTaskStatusAnalyse.pending, (state) => {
      state.createTaskAnalyseStatus = STATUS.PENDING;
    })
    .addCase(createTaskStatusAnalyse.fulfilled, (state, action: PayloadAction<any>) => {
      state.taskStatus = action.payload; 
      state.createTaskAnalyseStatus = STATUS.SUCESS; 
    })
    .addCase(createTaskStatusAnalyse.rejected, (state, action) => { 
      state.createTaskAnalyseStatus = STATUS.FAILED;
    })
};

export default ExtraReducers;
